/*
 * @Author: songyzh
 * @Date: 2020-07-31 06:20:40
 * @LastEditors: songyzh
 * @LastEditTime: 2020-08-20 11:13:32
 */
import Vue from 'vue';

// 检索目录下的模块
const req = require.context('.', true, /\.vue$/);

req.keys().forEach((fileName) => {
  const componentConfig = req(fileName);
  const name = fileName.name
    || fileName.replace(/^\.\/(.*\/)?/, '').replace(/\.vue$/, '');
  // 过滤掉不以 Nr 开头的 .vue 文件
  Vue.component(name, componentConfig.default || componentConfig);
});
